import type { CopilotInsightListItem, InsightListItemResponse } from "../types";

export const mapInsightListItem = (
	item: InsightListItemResponse
): CopilotInsightListItem => ({
	id: item.id,
	category: item.category,
	type: item.type,
	typeDescription: item.typeDescription,
	title: item.title,
	subtitle: item.subtitle ?? null,
	referenceDate: item.referenceDate,
	situationIdentified: item.situationIdentified,
	riskOfNoAction: item.riskOfNoAction,
	recommendedAction: item.recommendedAction,
	plate: item.plate?.trim() ? item.plate.trim() : null,
	driverName: item.driverName?.trim() ? item.driverName.trim() : null,
	isResolved: item.isResolved,
	wasHelpful: item.wasHelpful ?? null,
	weekStartDate: item.weekStartDate,
	createdAt: item.createdAt,
});
